<script lang="ts">
    import { fade } from "svelte/transition";
    import OutlineButton from "../common/outline-button.component.svelte";
    import RemoveIcon from "../ui/icons/icon-remove.svelte";
    import { createEventDispatcher } from "svelte";


    export let list: string[] = [];

    const dispatch = createEventDispatcher()

    const handleDelete = (item: string) => {
        dispatch("delete", item);
    }

</script>

<div>
    <ul>
        {#each list as item}
            <li transition:fade|local>
                <OutlineButton on:click={() => handleDelete(item)}>
                    <RemoveIcon />
                </OutlineButton>
                <span> {item} </span>
            </li>
        {/each}
    </ul>
</div>

<style>

    ul {
      list-style: none;
      padding: 20px 0px;
    }
    
    li {
        padding: 5px 5px;
    }
    
    ul > li > span {
        padding-left: 5px;
        font-weight: bold;
        font-size: larger;
    }

    
    
    
</style>
